import {
  DEFAULT_TITLE_OPTS,
  textareaSchema,
  textareaUI,
  titleWithFormDataUI,
} from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['health-insurance--addtl-comments-title'];
const INPUT_LABEL = content['health-insurance--addtl-comments-label'];
const HINT_TEXT = content['health-insurance--addtl-comments-hint'];

export default {
  uiSchema: {
    ...titleWithFormDataUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.insurance),
    additionalComments: textareaUI({
      title: INPUT_LABEL,
      hint: HINT_TEXT,
      charcount: true,
    }),
  },
  schema: {
    type: 'object',
    properties: {
      additionalComments: textareaSchema,
    },
  },
};
